/* @flow */
import Hovercard from 'components/Hovercard.jsx';
import List from 'components/List.jsx';
import React from 'react';

import cx from 'classnames';

import styles from './styles/NavigationMenu.css';

class NavigationMenu extends React.Component {
  render() {
    return (
      <Hovercard {...this.props} className={cx(styles.this, this.props.className)}>
        <List>
          {this.props.children}
        </List>
      </Hovercard>
    );
  }
}

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.jsx